export default function isMobileWidth() {
    const WIDTH = 767;

    return window.innerWidth <= WIDTH;
}